import { getTypes } from "./TypeGenerator";

export const ClassTypes = {
    ...getTypes("CLASS"),
};
